import { Component, OnInit } from "@angular/core";
import { SharedDataService } from "../../shared/sharedData.service";

@Component({
    selector: "timesheet-layout",
    templateUrl: "./timesheet-layout.component.html",
    standalone: false
})
export class TimesheetLayoutComponent implements OnInit {
    constructor(private _sharedDataService: SharedDataService) {}
    title = "";
    user: any = {};

    ngOnInit() {
        this._sharedDataService.setCss("timesheet");
    }
}
